import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const benefits = [
  { title: "Neural Pattern Audit", desc: "Our engine looks for GAN noise and diffusion artifacts common in AI synthesis.", icon: FiIcons.FiCpu, color: "text-blue-400" },
  { title: "Zero-Knowledge Privacy", desc: "Analysis runs 100% locally. Your sensitive data never crosses the network.", icon: FiIcons.FiLock, color: "text-purple-400" },
  { title: "Software Attribution", desc: "Identify signatures from Midjourney, Stable Diffusion, and DALL-E in metadata.", icon: FiIcons.FiActivity, color: "text-orange-400" },
  { title: "Certified Reporting", desc: "Generate evidence logs with timestamp timelines and risk factor breakdowns.", icon: FiIcons.FiFileText, color: "text-green-400" }
];

const Benefits = () => (
  <section className="py-20 border-t border-slate-900" aria-labelledby="features-heading">
    <h3 id="features-heading" className="text-xs font-black text-center mb-12 uppercase tracking-[0.3em] text-slate-500">Forensic Capabilities</h3>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 px-4">
      {benefits.map((b, i) => (
        <article key={i} className="p-8 bg-slate-900/50 rounded-3xl border border-slate-800 hover:border-blue-500/30 transition-all group">
          <div className={`${b.color} mb-6 transform group-hover:scale-110 transition-transform`}>
            <SafeIcon icon={b.icon} className="text-3xl" />
          </div>
          <h4 className="font-bold text-white mb-3 text-lg">{b.title}</h4>
          <p className="text-sm text-slate-500 leading-relaxed font-medium">{b.desc}</p>
        </article>
      ))}
    </div>
  </section>
);

export default Benefits;